import {
  electronicFormatIBAN,
  friendlyFormatIBAN,
  getCountrySpecifications,
  isValidIBAN,
} from 'ibantools'

const GLOBAL_MAX_IBAN_LENGTH = 34

export function normalizeIban(value: string | null | undefined): string {
  return (
    electronicFormatIBAN((value ?? '').replace(/[^a-zA-Z0-9 -]/g, '')) ?? ''
  ).slice(0, GLOBAL_MAX_IBAN_LENGTH)
}

export function formatIban(value: string | null | undefined): string {
  return friendlyFormatIBAN(normalizeIban(value)) ?? ''
}

export function isValidIban(value: string | null | undefined): boolean {
  const normalized = normalizeIban(value)
  return normalized.length > 0 && isValidIBAN(normalized)
}

export function getIbanMaxLength(value: string | null | undefined): number {
  const normalized = normalizeIban(value)
  const countryCode = normalized.slice(0, 2)

  if (!/^[A-Z]{2}$/.test(countryCode)) {
    return GLOBAL_MAX_IBAN_LENGTH
  }

  const spec = getCountrySpecifications()[countryCode]
  return spec?.chars ?? GLOBAL_MAX_IBAN_LENGTH
}
